import { z } from 'zod';
import { BillingCycles } from './billing-cycles.enum';
import { CompanyPlanTypes } from './company-plan-types.enum';
import { FlowsitePlanTypes } from './flowsite-plan-types.enum';
import { PaymentCurrencyTypes } from './payment-currency-types.enum';
import { PaymentMethods } from './payment-methods.enum';
import { PaymentTermContexts } from './payment-term-contexts.enum';
import { SubscriptionStatuses } from './subscription-statuses.enum';
import { SubscriptionTerms } from './subscription-terms.enum';
export var DashpivotBillingSettingsSchema = z.object({
    trialEndDate: z.string().datetime().nullish(),
    planType: z.nativeEnum(CompanyPlanTypes),
    subscriptionStatus: z.nativeEnum(SubscriptionStatuses).nullish(),
    initialSubscriptionDate: z.string().datetime().nullish(),
    subscriptionTerm: z.nativeEnum(SubscriptionTerms).nullish(),
    billingCycle: z.nativeEnum(BillingCycles).nullish(),
    /**
     * The number of Dashpivot Contributor users an account has paid for in their billing (across all Dashpivot workspaces).
     */
    contributorUsersPaid: z.number().min(0).nullish(),
    /**
     * The number of Sitemate Paid Users an account has paid for in their billing (across all products workspaces).
     */
    sitematePaidUsersPaid: z.number().min(0).nullish(),
});
export var FlowsiteBillingSettingsSchema = z.object({
    trialEndDate: z.string().datetime().nullish(),
    planType: z.nativeEnum(FlowsitePlanTypes),
    subscriptionStatus: z.nativeEnum(SubscriptionStatuses).nullish(),
    initialSubscriptionDate: z.string().datetime().nullish(),
    subscriptionTerm: z.nativeEnum(SubscriptionTerms).nullish(),
    billingCycle: z.nativeEnum(BillingCycles).nullish(),
});
export var AccountBillingSettingsSchema = z.object({
    billingCompanyName: z.string(),
    billingAddress: z.string().nullish(),
    billingContact: z.string().nullish(),
    billingDate: z.string().datetime().nullish(),
    initialSubscriptionDate: z.string().datetime().nullish(),
    paymentTermDay: z.number().min(0).max(60).nullish(),
    paymentTermContext: z.nativeEnum(PaymentTermContexts).nullish(),
    paymentMethod: z.nativeEnum(PaymentMethods).nullish(),
    currency: z.nativeEnum(PaymentCurrencyTypes).nullish(),
    dashpivot: DashpivotBillingSettingsSchema.nullish(),
    flowsite: FlowsiteBillingSettingsSchema.nullish(),
});
